import { formValueSelector } from 'redux-form';

import { RootReducerStateT } from 'app/reducers/rootReducer';

export const messengerAppearanceFormName = 'dixa-messenger-widget-settings';

export const messengerSettingsFormValueSelector =
  formValueSelector<RootReducerStateT>(messengerAppearanceFormName);
